import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface TeamChatState {
  isOpen: boolean;
  selectedChannelId: string | null;
  open: () => void;
  close: () => void;
  toggle: () => void;
  selectChannel: (channelId: string | null) => void;
}

const TeamChatContext = createContext<TeamChatState | null>(null);

export function TeamChatStateProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedChannelId, setSelectedChannelId] = useState<string | null>(null);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen(prev => !prev), []);
  const selectChannel = useCallback((channelId: string | null) => setSelectedChannelId(channelId), []);

  return (
    <TeamChatContext.Provider value={{ isOpen, selectedChannelId, open, close, toggle, selectChannel }}>
      {children}
    </TeamChatContext.Provider>
  );
}

export function useTeamChatState() {
  const ctx = useContext(TeamChatContext);
  if (!ctx) throw new Error("useTeamChatState must be used within TeamChatStateProvider");
  return ctx;
}
